/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ProgressIndicator } from '@/components/blocks/ProgressIndicator';
import { Sidebar } from '@/components/blocks/SideBar';
import { FacetNavigationItemChange } from '@/components/content/FacetNavigation/parts/ItemChange';
import { FacetNavigationPriceChange } from '@/components/content/FacetNavigation/parts/PriceChange';
import { useFacetNavigation } from '@/data/Content/FacetNavigation';
import { useLocalization } from '@/data/Localization';
import { ContentProvider } from '@/data/context/content';
import { ID } from '@/data/types/Basic';
import { isEmpty } from 'lodash';
import { FC, useEffect, useMemo } from 'react';
import { sidebarAccordionSummarySXP, sidebarAppBarContainerSXP, sidebarAppBarContentSXP } from './styles/sidebar';
import { getElementHeight } from '@/utils/getELementHeight';
import { useDeviceType } from '@/data/deviceDetection';

export const FacetNavigation: FC<{ id: ID }> = ({ id }) => {
	const facetNavigation = useFacetNavigation(id);
	const { Labels } = useLocalization('ProductFilter');
	const { available, loading, filteredParams, facets, facetFilters } = facetNavigation;
	const { searchTerm } = filteredParams;
	const showFilter = useMemo(
		() => facets.length || !isEmpty(facetFilters) || (available && !searchTerm),
		[facets, facetFilters, available, searchTerm]
	);
	const {isMobile} = useDeviceType();

	useEffect(() => {
		if (isMobile) {
			const facetNavigationAppbarHeight = getElementHeight("#facet_navigation_appbar");
			if(facetNavigationAppbarHeight > 0){
				const empty_space_place_holder = document.querySelector<HTMLElement>("#empty_space_place_holder");
				if(empty_space_place_holder){
					empty_space_place_holder.style.height = `${facetNavigationAppbarHeight+5}px`; // place holder height
				}
			}
		};
	}, [isMobile]);

	return loading ? (
		<ProgressIndicator />
	) : available || searchTerm ? (
		<ContentProvider value={facetNavigation}>
		{showFilter &&	<Sidebar
				title={showFilter ? Labels.filterBy.t() : Labels.noFilters.t()}
				scrollable={true}
				{...{
					sidebarAppBarContainerSXP,
					sidebarAppBarContentSXP,
					sidebarAccordionSummarySXP,
					appBarId:'facet_navigation_appbar'
				}}
			>
				<FacetNavigationPriceChange />
				<FacetNavigationItemChange />
			</Sidebar> }
		</ContentProvider>
	) : null;
};
